import styled from 'styled-components';
export const StyledMarkets = styled.button`
  background-color: ${(props) => props.selected ? props.theme.marketsSelected_BG : props.theme.markets_BG} !important;
  border: 1px solid ${(props) => props.selected ? props.theme.marketsSelected_border : props.theme.markets_border} !important;
  color: ${(props) => props.selected ? props.theme.marketsSelected_text : props.theme.markets_text} !important;
`;
